import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9 2.25A6.744 6.744 0 002.25 9 6.744 6.744 0 009 15.75 6.744 6.744 0 0015.75 9 6.744 6.744 0 009 2.25zM9 14.4A5.399 5.399 0 013.6 9c0-2.984 2.416-5.4 5.4-5.4 2.983 0 5.4 2.416 5.4 5.4 0 2.983-2.417 5.4-5.4 5.4z" fill="#54585D" /></svg>);